import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {AuxiliaresContainer} from './Screen';

export const AuxiliaresView = () =>{

    return (
        <Page title={'Auxiliares'}>{<AuxiliaresContainer/>}</Page>
    )
}